import { LitElement, TemplateResult, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./GameItemDisplay";

@customElement("player-inventory")
export class PlayerInventory extends LitElement {
    @property({ type: Array }) private inventory: any[] | undefined = [];
    @property({ type: Array }) private gameObjects: any[] | undefined = [];
    public static styles = css`
        .inventory {
            position: absolute;
            top: 0;
            right: 0;
            margin-top: 3%;
            height: 90%; /* adjust as needed */
            padding: 10px;
            width: 300px;

            background-color: #103a00;
            border: 7px solid #008015;
            border-right: none;
            border-radius: 10px 0 0 10px;
        }
        .inventory .title {
            text-align: center;
            margin-bottom: 10px;
        }
        .inventory .item {
            margin-bottom: 10px;
        }
        .button {
            position: absolute;
            top: 0;
            right: 0;
            padding: 10px;
            background-color: #003b0a;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            visibility: hidden;
        }
        @keyframes slide-in {
            0% {
                transform: translateX(100%);
            }
            100% {
                transform: translateX(0);
            }
        }

        @keyframes slide-out {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(100%);
            }
        }

        @media (max-width: 1600px) {
            .inventory {
                display: block;
                animation: slide-out 0.5s forwards;
                position: fixed;
            }
            .inventory.show {
                display: block;
                animation: slide-in 0.5s forwards;
                position: fixed;
            }
            .button {
                visibility: visible;
            }
        }
    `;

    private inventoryVisible = false;

    private constructor() {
        super();
        this.inventory = []; // Initialize inventory with an empty array
    }

    private toggleInventory(): void {
        this.inventoryVisible = !this.inventoryVisible;
        this.requestUpdate();
    }

    protected render(): TemplateResult {
        return html`
            <div class="inventory ${this.inventoryVisible ? "show" : ""}">
                <div class="title">Inventory</div>
                <div id="Item list">${this.renderItems()}</div>
            </div>
            <button @click=${this.toggleInventory} class="button">Toggle Inventory</button>
        `;
    }
    private renderItems(): TemplateResult[] | void {
        if (this.inventory === undefined) return;
        return this.inventory.map((item) => {
            return html` <display-item-menu
                .item=${item}
                .gameObjects=${this.gameObjects}
                @action-clicked=${(e: CustomEvent): void => {
                    void this.dispatchEvent(
                        new CustomEvent("action-clicked", {
                            detail: { button: e.detail.button, item: e.detail.item },
                        }),
                    );
                }}
            ></display-item-menu>`;
        });
    }
}
